import axios from "axios";
// import store from "@/store"
// import router from "@/router"
// import { Message } from "element-ui"
import { getToken } from "@/utils/auth";

const request = axios.create({
  baseURL: process.env.VUE_APP_URL + "/dynamic-form",
  timeout: 30000,
  // withCredentials: true,
});

request.interceptors.request.use(
  (config) => {
    config.headers.Authorization = getToken() ? getToken() : "";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  (res) => {
    if (res.data == "未登录或登录过期，请重新登录!") {
      // sessionStorage.clear()
      // store.dispatch("auth/init")
      // router.replace("/login")
      // return Message({
      //   message: res.data,
      //   type: "warning"
      // })
    } else if (res.status == 200) {
      return res.data;
    } else return res;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default request;
